/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { init } from 'i18next';
import * as actiontypes from './actiontypes';

const initialState = {
  modificationFromAr: [],
  getSingleAccRecNDCDetailList: [],
  singleNdcDetailList: [],
  getBalnceDue: [],
  getOverridden: [],
  getPaidInFull: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.SINGLE_ACC_REC_NDC__DETAIL_TABLE:
      let getPgmVal = Object.keys(action.getSingleAccRecNDCDetailList)[0];
      if ((state.getSingleAccRecNDCDetailList || []).length !== 0) {
        state.getSingleAccRecNDCDetailList.forEach(function (obj) {
          delete obj[getPgmVal];
        });
      }

      return {
        ...state,
        getSingleAccRecNDCDetailList: [
          ...(state.getSingleAccRecNDCDetailList || []).filter(
            (value) => Object.keys(value).length !== 0
          ),
          action.getSingleAccRecNDCDetailList,
        ],
      };
    case actiontypes.SINGLE_NDC_DETAIL:
      let getAccRecNDCPgmVal = Object.keys(action.singleNdcDetailList)[0];
      if (state.singleNdcDetailList?.length != 0) {
        let main = state?.singleNdcDetailList?.forEach(function (obj) {
          delete obj[getAccRecNDCPgmVal];
        });
      }
      return {
        ...state,
        singleNdcDetailList: [
          ...(state.singleNdcDetailList || []).filter(
            (value) => Object.keys(value).length !== 0
          ),
          action.singleNdcDetailList,
        ],
      };
    case actiontypes.NDC_BALANCE_DUE:
      let getAccRecPgmBLVal = Object.keys(action?.getBalnceDue)?.[0];
      if (state?.getBalnceDue?.length != 0) {
        let main = state?.getBalnceDue?.forEach(function (obj) {
          delete obj[getAccRecPgmBLVal];
        });
      }
      return {
        ...state,
        getBalnceDue: [
          ...(state?.getBalnceDue || []).filter(
            (value) => Object.keys(value).length !== 0
          ),
          action?.getBalnceDue,
        ],
      };
    case actiontypes.NDC_OVERRIDDEN:
      let getAccRecPgmORVal = Object.keys(action?.getOverridden)?.[0];
      if (state?.getOverridden?.length != 0) {
        let main = state?.getOverridden?.forEach(function (obj) {
          delete obj[getAccRecPgmORVal];
        });
      }
      return {
        ...state,
        getOverridden: [
          ...(state?.getOverridden || []).filter(
            (value) => Object.keys(value).length !== 0
          ),
          action?.getOverridden,
        ],
      };
    case actiontypes.NDC_PAID_FULL:
      let getAccRecPgmPDVal = Object.keys(action?.getPaidInFull)?.[0];
      if (state?.getPaidInFull?.length != 0) {
        let main = state?.getPaidInFull?.forEach(function (obj) {
          delete obj[getAccRecPgmPDVal];
        });
      }
      return {
        ...state,
        getPaidInFull: [
          ...(state?.getPaidInFull || []).filter(
            (value) => Object.keys(value).length !== 0
          ),
          action?.getPaidInFull,
        ],
      };
    case actiontypes.MODIFICATION_FROM_AR:
      return { ...state, modificationFromAr: action.modificationFromAr };
    case actiontypes.AR_NDC_DETAIL_FIRST_LOAD:
      return { ...state, ndcDetailFirstLoad: action.payload };
    case actiontypes.ACCOUNT_REC_NDC_DETAIL_CLEAR_REDUX:
      return action.payload ? action.payload : { modificationFromAr: [] };
    default:
      return state;
  }
};

export default reducer;
